import React, { useEffect } from 'react'
import HomeBanner from './HomeBanner'
import HomeCounting from './HomeCounting'
import HomeTopCategorys from './HomeTopCategorys'
import HomeAbout from './HomeAbout'
import HomeAllCourses from './HomeAllCourses'
import HomeSubscribe from './HomeSubscribe'
import HomeFaq from './HomeFaq'
import HomeStartJourny from './HomeStartJourny'
import HomeAbout2 from './HomeAbout2'
import HomeWhyChoose from './HomeWhyChoose'
import HomeTrainings from './HomeTrainings'
import HomeWellLikedCourse from './HomeWellLikedCourse'
import HomeBlogs from './HomeBlogs'
import HomeContactForm from './HomeContactForm'
import Footer from '../Footer/Footer'
import HomeContent from './HomeContent'
import Navbar from '../Navbar/Navbar'


const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);
  return (
    <>
      <div className="floating-icons">
        <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
          <button

            className="sm_icon"
          >
            <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
          </button>
        </a>
        <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
          </button>
        </a>
        <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
          </button>
        </a>
        <a className="icon" href="https://wa.me/+918688964015" target="_blank">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
          </button>
        </a>
      </div>


      <div>
        {/* <Navbar /> */}
        <HomeBanner />
        <HomeCounting />
        <HomeAbout />
        {/* <HomeTopCategorys /> */}
        <HomeAllCourses />
        <HomeSubscribe />
        <HomeFaq />
        <HomeStartJourny />
        <HomeAbout2 />
        <HomeWhyChoose />
        <HomeTrainings />
        <HomeWellLikedCourse />
        <HomeBlogs />
        <HomeContactForm />
        <HomeContent />
        {/* <Footer /> */}
      </div>
    </>
  )
}

export default Home
